import React from 'react';
type WatermarkedImageProps = {
  src: string;
  alt: string;
  className?: string;
  wrapperClassName?: string;
  size?: 'sm' | 'md';
};

/**
 * Renders a blog image with a subtle IntelliEats brand watermark
 * (black wordmark + green accent) overlaid in the bottom-right corner.
 * The watermark stays light enough not to obscure the artwork.
 */
export function WatermarkedImage({
  src,
  alt,
  className = '',
  wrapperClassName = '',
  size = 'md'
}: WatermarkedImageProps) {
  const isSmall = size === 'sm';
  return <div className={`relative inline-block w-full overflow-hidden ${wrapperClassName}`} data-id="element-1526" data-mp="3j7u10hotrlwk">
      <img src={src} alt={alt} className={className} data-id="element-1527" data-mp="3o0wl7z7ppj03" />
      <span aria-hidden="true" className={`pointer-events-none absolute select-none rounded-full bg-white/70 font-black tracking-tight backdrop-blur-sm ${isSmall ? 'bottom-1.5 right-1.5 px-2 py-0.5 text-[9px]' : 'bottom-3 right-3 px-3 py-1 text-xs sm:text-sm'}`} data-id="element-1528" data-mp="3o27rq6sjl4uw">
        <span className="text-slate-900/70" data-id="element-1529" data-mp="1edzvlz0ku150">Intelli</span>
        <span className="text-brand-600/80" data-id="element-1530" data-mp="1ebddj5g2838j">Eats</span>
      </span>
    </div>;
}